import React from "react";
import "./view-crm-plan-details.scss";
import { Box, Button } from "@mui/material";
import icons from "../../../../../assets/icons/icons";

interface ViewCrmPlanDetailsProps {
  activeTab: any;
  titile: any;
  setIsEditBasic: any;
  plans?: any;
}
const ViewCrmPlanDetails: React.FC<ViewCrmPlanDetailsProps> = ({
  activeTab,
  titile,
  setIsEditBasic,
  plans,
}) => {
  const hexColors: string[] = [
    "#D59F55",
    "#CD5C5C",
    "#4B3B31",
    "#004C4C",
    "#F87EA1",
    "#E48E66",
    "#556B2F",
    "#8E44AD",
  ];
  return (
    <Box
      className="view-crm-plan-details-wrapper"
      sx={{
        borderTop: `10px solid ${plans?.themeColor || "white"}`,
      }}
    >
      <div className="view-plan-header-div">
        <div className="plan-header">{plans?.planName || ""}</div>
        <Button
          variant="outlined"
          className="edit-button"
          onClick={() => setIsEditBasic(true)}
        >
          Edit Details
        </Button>
      </div>
      <p className="plan-sub-head">
        {plans?.subHeading ?? plans?.suitedFor ?? ""}
      </p>
     
      <Box
        sx={{
          display: "flex",
          gap: 1,
          width: "100%",
          overflowX: "auto",
          boxSizing: "border-box",
        }}
      >
        {hexColors?.map((color: string, index: number) => (
          <Box
            sx={{
              maxWidth: "31px",
              maxHeight: "31px",
              width: "100%",
              height: "100%",
              flex: "1 0 31px",
              minWidth: "31px",

              minHeight: "31px",
              borderRadius: "50%",
              background: color,
              position: "relative",
            }}
          >
            {color === plans?.themeColor && (
              <Box
                sx={{
                  position: "absolute",
                  top: "6px",
                  left: "8px",
                }}
              >
                <img src={icons.Tick} />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ViewCrmPlanDetails;
